import {
  getPhaseConnectivityOptions, getPhaseConnectivitySource, getPhasesOptions, getPhasesSource,
} from '../helper';
import {
  DEFAULT_ALL_DAYS_SCHEDULE_TITLE,
  DEFAULT_WEEKDAYS_SCHEDULE_TITLE,
  DEFAULT_WEEKENDS_SCHEDULE_TITLE,
} from './const';
import { ALL_DAYS_SCHEDULE_DAY_TYPE, WEEKDAYS_SCHEDULE_DAY_TYPE, WEEKENDS_SCHEDULE_DAY_TYPE } from '../../../constants';
import {
  connectedPhases,
  required,
  scheduleFiledValidator,
  scScheduleFieldValidator,
} from '../../../../../../common/services/ValidationRules';

export const makePhaseConnectivityRule = (params = {}) => ({
  label: 'Phase Connectivity Type',
  source: getPhaseConnectivitySource,
  name: 'phaseConnectivityType',
  type: 'select',
  options: ({ parent, nodes }) => getPhaseConnectivityOptions(parent, nodes),
  helperText: ({ parent }) => (parent === null ? 'Parent node required' : null),
  disabled: ({ parent }) => parent === null,
  required: ({ parent }) => parent !== null,
  validators: ({ parent }) => (parent === null ? [] : [required]),
  style: { width: '49%' },
  ...params,
});

export const makePhasesRule = (params = {}) => ({
  label: 'Connected Phases',
  source: getPhasesSource,
  name: 'phases',
  type: 'select',
  options: getPhasesOptions,
  helperText: ({ parent }) => (parent === null ? 'Parent node required' : null),
  disabled: ({ parent }) => parent === null,
  required: ({ parent }) => parent !== null,
  validators: ({ parent }) => (parent === null ? [] : [connectedPhases]),
  style: { width: '49%' },
  ...params,
});

export const makeScheduleCommonFields = ({ fromProps = {}, toProps = {} }) => [
  {
    label: 'From',
    source: 'from',
    name: 'from',
    type: 'timeFrom',
    isRequired: true,
    validators: [],
    minutesStep: 30,
    style: {
      width: '14%',
    },
    ...fromProps,
  },
  {
    label: 'To',
    source: 'to',
    name: 'to',
    type: 'timeTo',
    isRequired: true,
    validators: [],
    minutesStep: 30,
    style: {
      width: '14%',
    },
    ...toProps,
  },
];

export const makeWeekdaysScheduleRule = (fields, params = {}, isSCSchedule = false) => {
  const validators = [scheduleFiledValidator];

  if (isSCSchedule) {
    validators.push(scScheduleFieldValidator);
  }

  return {
    title: DEFAULT_WEEKDAYS_SCHEDULE_TITLE,
    tag: 'schedule',
    fields: [
      {
        type: 'schedule',
        name: WEEKDAYS_SCHEDULE_DAY_TYPE,
        source: ({ node }) => node.staticSection.schedules.find((schedule) => schedule.dayType === WEEKDAYS_SCHEDULE_DAY_TYPE),
        fields,
        validators,
        scSchedule: isSCSchedule,
      },
    ],
    ...params,
  };
};

export const makeWeekendsScheduleRule = (fields, params = {}, isSCSchedule = false) => {
  const validators = [scheduleFiledValidator];

  if (isSCSchedule) {
    validators.push(scScheduleFieldValidator);
  }

  return {
    title: DEFAULT_WEEKENDS_SCHEDULE_TITLE,
    tag: 'schedule',
    fields: [
      {
        type: 'schedule',
        name: WEEKENDS_SCHEDULE_DAY_TYPE,
        source: ({ node }) => node.staticSection.schedules.find((schedule) => schedule.dayType === WEEKENDS_SCHEDULE_DAY_TYPE),
        fields,
        validators,
        scSchedule: isSCSchedule,
      },
    ],
    ...params,
  };
};

export const makeAllDaysScheduleRule = (fields, params = {}) => ({
  title: DEFAULT_ALL_DAYS_SCHEDULE_TITLE,
  tag: 'schedule',
  fields: [
    {
      type: 'schedule',
      name: ALL_DAYS_SCHEDULE_DAY_TYPE,
      source: ({ node }) => node.staticSection.schedules.find((schedule) => schedule.dayType === ALL_DAYS_SCHEDULE_DAY_TYPE),
      fields,
      validators: [],
    },
  ],
  ...params,
});
